<template>
  <div class="cmodal h-card shadow">
    <div class="card-header" :class="{error: error}">
      <h5 class="modal-title">{{title}}</h5>
      <button type="button" @click="closeCmodal" class="btn-close" data-bs-dismiss="modal" aria-label="Закрыть"></button>
    </div>
    <div class="card-body" v-html=message></div>
    <div class="card-footer">
      <button class="close-btn" @click="confirmAct">ОК</button>
    </div>
  </div>
</template>
<script>
import {popModal} from "jenesius-vue-modal";

export default {
  name: 'ConfirmModal',
  props: {
    message: String,
    title: String,
    error: Boolean,
  },
  data() {
    return {
    }
  },
  created() {
  },
  computed: {

  },
  methods:{
    closeCmodal(){
      popModal();
    },
    confirmAct(){
      popModal();
      this.$emitter.emit('autoAddBooking')
    }
  }
}
</script>
<style scoped>
.cmodal {
  max-width: 460px;
}
.cmodal textarea{
  border-radius: .3em;
}
.cmodal .card-header{
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}
.cmodal .card-header.error{
  background: #ff5f5f80;
}

.cmodal label{
  margin-bottom: 0.1rem;
  font-size: 0.85rem;
  color: #ad8b57;
}

.cmodal .hint{
  margin-top: 0.1rem;
  font-size: .75em;
  color:#999;
}
.cmodal  .card-body {
  overflow: auto;
  //height: 400px;
  height: fit-content;
  max-height: 95vh;
}
</style>